module.exports = __webpack_public_path__ + "img/ka5-2.ee85ec94.png";